import { FC, useState } from "react";
import Header from "../../header/Header";
import HeroSection from "./HeroSection";
import MarketsSection from "./MarketsSection";
import DiscoverMarketsSection from "./DiscoverMarketsSection";
import OrganisatorsSection from "./OrganisatorsSection";
import Footer from "../../footer/Footer";
import GallerySection from "./GallerySection";

const Main: FC = () => {
    const [backgroundBlur, setBackgroundBlur] = useState(false);

    return (
        <>
            <Header backgroundBlur={backgroundBlur} setBackgroundBlur={setBackgroundBlur} />
            <div className={backgroundBlur && "blur"}>
                <HeroSection />
                <MarketsSection />
                <DiscoverMarketsSection />
                <OrganisatorsSection />
                <GallerySection />
                <Footer />
            </div>
        </>
    );
};

export default Main;
